module.exports = __webpack_public_path__ + "img/jingbao2.gif";